// BootstrapのJavaScript側の機能を読み込む
import 'bootstrap';
import 'slick-carousel';
// Bootstrap以外のJavaScriptを読み込む
import './js/i-measure_script.js';
// HTMLファイルを読み込む
import './index.html';
// スタイルシートを読み込む
import './scss/i-measure_styles.scss';
